//3rd Party Components
import React, { Fragment } from 'react';
import AUpageAlert from '@gov.au/page-alerts';
import { useSelector } from "react-redux";
import MetaTags from 'react-meta-tags';
import { AUformGroup } from '@gov.au/form';
import AUdirectionLink from '@gov.au/direction-links';

//Actions
import { getUrlSelector } from '../PortalStore/Selectors/EnvDataSelectors';
import { getPortalUrl } from '../components/Portal/Utilities';
import { urlSearchValue } from '../components/Portal/Utilities';

export const ServiceUnavailable = () => {
    let standalone = useSelector(state => state.B2CSettings.items.standalone);
    let urlHome = useSelector(state => getUrlSelector(state, "Portal - Home URL"));

    const loc = getPortalUrl("/", standalone, urlHome); 

    let msg = urlSearchValue("code");

    return (
        <Fragment>
            <MetaTags>
                <title>Warning</title>
            </MetaTags>
            <br />
            <AUpageAlert as="warning">
                <h3>No services available</h3>
                <p>
                    Currently you have no service available
                </p>
            </AUpageAlert>

            <div>
                <AUformGroup>
                    <AUdirectionLink link='/dashind' text='Return to myCASA' direction='left' style={{ marginTop: '20px' }} />
                </AUformGroup>
            </div>

        </Fragment>

    );
    
}

